import { batch } from "react-redux";
import { fetchAppFreeBets, getRiskFreeBets } from "@nxplatform/betslip/betslip-freebets.slice";
import { promotionList } from "@nxplatform/bonuses/customer-promotion.slice";
import { fetchCasinoCategories } from "@nxplatform/casino/casino-category.slice";
import { selectCustomerRestorePasswordTokenLoaded, selectCustomerRestorePasswordTokenError, customerCheckRestorePasswordToken } from "@nxplatform/customer-noauth/slices/customer-noauth.slice";
import { markCustomerActivity } from "@nxplatform/customer-noauth/slices/customer-token.slice";
import { selectTextPageWithoutPromoSnackbar } from "@nxplatform/customer-noauth/slices/text-pages.slice";
import { selectCurrencyVariablesEntities } from "@nxplatform/geo-data/slices/currency-variables.slice";
import { selectCustomerIpCountry, selectRegistrationStarted, selectIpDataEntities, selectIpDataLoaded, registrationSuccess, changeCustomerData } from "@nxplatform/geo-data/slices/ip-data.slice";
import { ApiRenderComponentMenu } from "@nxplatform/helpers/entities";
import { DisabledStatus } from "@nxplatform/platform-entities";
import { selectRecaptchaKey, selectProjectBaseCurrency, selectWsEndpoint, isDisabledPromotions, selectLocaleSetupPrimaryLanguage, selectLocaleSetupLanguagesRoutes } from "@nxplatform/platform-settings/locale-setup.selectors";
import { resetTextPageState } from "@nxplatform/platform-settings/platform-settings.slice";
import { getBetRadarAliveClear } from "@nxplatform/sport/betradar-setup.slice";
import { selectCustomerConfirmationToken } from "@nxplatform/store-shared/authentication/shared-authentication-selectors";
import { checkCustomerLimitToken, getCustomerTokenSuccess, customerOpenBasicModal, customerData, getCustomerWSToken } from "@nxplatform/store-shared/customer/shared-customer-actions";
import { selectIsGBGStatusNotSet, selectCustomerMainCurrency, selectCustomerLimitsTokenSuccess, selectCustomerEntities, selectCustomerTokenEntities } from "@nxplatform/store-shared/customer/shared-customer-selectors";
import { selectPublicWsConnectionAliveChannels, selectPublicWsConnected, removeAliveChannels, addAliveChannels } from "@service/api-client/slices";
import { selectIsMainMenuCmsHeader, fetchMainMenuCms } from "./cms/menu.slice.js";
import { setupAppInit } from "./root-epic-setup.js";
import { selectFullPlatformSettingsLoaded, selectShowNecctonNotificationEnabled, selectMobileBottomMenu, selectApiRenderMenuByNameEnabled, selectNewTopMenu, selectPromoOfferPopupEnabled, selectWsIsActive, selectPlatformSettingsIsText, selectPlatformSettingsLoaded } from "@nxplatform/platform-settings/platform-settings.selectors";
const getLoadedState = (state) => {
  if (!window.debugPerformance) {
    return selectPlatformSettingsLoaded(state) && selectIpDataLoaded(state);
  }
  return true;
};
const mapStateToProps = (state) => {
  var _a;
  return {
    auth: selectCustomerTokenEntities(state),
    customer: selectCustomerEntities(state),
    loaded: getLoadedState(state),
    isTextPage: selectPlatformSettingsIsText(state),
    languages: selectLocaleSetupLanguagesRoutes(state),
    confirmationSuccess: selectCustomerConfirmationToken(state),
    primaryLanguage: selectLocaleSetupPrimaryLanguage(state),
    disabledPromotions: isDisabledPromotions(state),
    tokenError: selectCustomerRestorePasswordTokenError(state),
    limitTokenSuccess: selectCustomerLimitsTokenSuccess(state),
    tokenLoaded: selectCustomerRestorePasswordTokenLoaded(state),
    wsEndpoint: selectWsEndpoint(state),
    wsActive: selectWsIsActive(state),
    promoOfferPopupEnabled: selectPromoOfferPopupEnabled(state),
    currencyVariables: selectCurrencyVariablesEntities(state),
    customerIpData: selectIpDataEntities(state),
    customerMainCurrency: selectCustomerMainCurrency(state),
    baseCurrencyCode: selectProjectBaseCurrency(state),
    newTopMenu: selectNewTopMenu(state),
    isMenuCms: selectIsMainMenuCmsHeader(state),
    menuMainCmsHeaderEnabled: selectApiRenderMenuByNameEnabled(state, ApiRenderComponentMenu.header),
    menuMainCmsTopEnabled: selectApiRenderMenuByNameEnabled(state, ApiRenderComponentMenu.top),
    mobileBottomMenu: selectMobileBottomMenu(state),
    publicWsConnected: selectPublicWsConnected(state),
    publicWsAliveChannels: selectPublicWsConnectionAliveChannels(state),
    recaptchaKey: selectRecaptchaKey(state) || ((_a = window == null ? void 0 : window.PlatformSetup) == null ? void 0 : _a.RECAPTCHA_SITE_KEY),
    showNecctonNotificationEnabled: selectShowNecctonNotificationEnabled(state),
    isGBGStatusLoading: selectIsGBGStatusNotSet(state),
    registrationStarted: selectRegistrationStarted(state),
    pageWithoutPromoSnackbar: selectTextPageWithoutPromoSnackbar(state),
    country: selectCustomerIpCountry(state),
    fullSettingsLoaded: selectFullPlatformSettingsLoaded(state)
  };
};
const mapDispatchToProps = (dispatch) => ({
  setup: () => {
    dispatch(setupAppInit());
  },
  clearState: () => {
    dispatch(getBetRadarAliveClear());
  },
  customerSocket: (customer, wsActive) => {
    if (wsActive) {
      dispatch(getCustomerWSToken());
    }
  },
  getCustomerInfo: () => {
    dispatch(customerData());
  },
  getPromotionsList: (disabledPromotions, disabledStatusCode) => {
    if (!disabledPromotions) {
      if (disabledStatusCode !== DisabledStatus.block_id_upload) {
        batch(() => {
          dispatch(promotionList());
          dispatch(fetchAppFreeBets());
          dispatch(getRiskFreeBets());
        });
      }
    }
  },
  openModal: (modalType) => {
    dispatch(customerOpenBasicModal(modalType));
  },
  tokenLogin: (token) => {
    dispatch(getCustomerTokenSuccess({ token }));
  },
  changeBonusType: (payload) => {
    dispatch(changeCustomerData({ bonusType: payload }));
  },
  setRegistrationSuccess: (state) => {
    dispatch(registrationSuccess(state));
  },
  checkRestorePasswordToken: (token) => {
    dispatch(customerCheckRestorePasswordToken(token));
  },
  checkLimitToken: ({ limitToken, limitId }) => {
    dispatch(checkCustomerLimitToken({ limitToken, limitId }));
  },
  clearIsTextPageFlag: () => {
    dispatch(resetTextPageState());
  },
  getCategories: (auth, categoryRecentlyPlayedEnabled) => {
    dispatch(fetchCasinoCategories({ auth, categoryRecentlyPlayedEnabled }));
  },
  markUserActivity: () => {
    dispatch(markCustomerActivity());
  },
  getMenu: (params) => {
    dispatch(fetchMainMenuCms(params));
  },
  addPublicWsChannels: (payload) => {
    dispatch(addAliveChannels(payload));
  },
  removePublicWsChannels: (payload) => {
    dispatch(removeAliveChannels(payload));
  }
});
const routeSwitcherConnect = {
  mapDispatchToProps,
  mapStateToProps
};
export {
  routeSwitcherConnect
};
